// MBQ OCT 2025 RESTYLING
import React from 'react'
import envSettings from '../../globals/envSettings'
import { Progress } from 'reactstrap'
import { useLocation } from 'react-router-dom'
import { AuthConsumer } from 'react-check-auth'

const LinkToNewApp = props => {
  const location = useLocation()

  /*let pathname = location.pathname || '/home'
  if(/^\/(administration|admin)($|\/.*)/.test(pathname)) {
    if(props.userInfo) {
      pathname = '/home'  
    } else {
      pathname = '/signin'
    }    
  }*/
  // We redirect to the Premium-restyling home page to avoid the error page
  // in case the APP route does not exist
  let pathname = '/home'
  if(/^\/(administration|admin)($|\/.*)/.test(location.pathname) && !props.userInfo) {
    pathname = '/signin'
  }

  window.location.href = envSettings.NEW_APP_BASEURL.concat(pathname)

  return (
    <Progress animated color='primary' value='100' />
  )
}

export default () => (
  <AuthConsumer>
    {({ userInfo }) => <LinkToNewApp userInfo={userInfo} />
    }
  </AuthConsumer>
)